<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>Crear Productos Compras <span v-if="producto.nro != null">{{ producto.nro }}</span></h2></v-toolbar-title></pre>
                    </v-toolbar>
                    <v-form class="mt-3">
                        <v-col cols="12">
                            <router-link to="lista-productos-compras">
                                <v-btn color="red" class="white--text" s>
                                    Volver
                                </v-btn>
                            </router-link>
                        </v-col>
                        <form ref="form">
                            <input
                                :value="$route.query.id"
                                v-if="$route.query.id != null"
                                name="id"
                                style="display: none"
                            />
                            <v-row>
                                <v-col cols="12" md="2">
                                    <v-text-field
                                        v-model="producto.nro"
                                        label="Número"
                                        name="nro"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model="producto.nombre"
                                        label="Nombre"
                                        name="nombre"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <proveedoresSelect
                                        v-model="producto.id_proveedor"
                                        label="Proveedor"
                                        required
                                    ></proveedoresSelect>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-autocomplete
                                        type="number"
                                        v-model="producto.id_iva"
                                        label="IVA"
                                        name="id_iva"
                                        :items="ivas"
                                        item-text="descripcion"
                                        item-value="id"
                                        required
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-text-field-comma
                                        type="number"
                                        v-model="producto.precio_original"
                                        label="Precio original"
                                        name="precio_original"
                                    ></v-text-field-comma>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-text-field-comma
                                        type="number"
                                        v-model="producto.precio"
                                        label="Precio final"
                                        name="precio"
                                        required
                                    ></v-text-field-comma>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-text-field-comma
                                        v-model="producto.codigo"
                                        label="Código de barras"
                                        name="codigo"
                                        required
                                    ></v-text-field-comma>
                                </v-col>
                            </v-row>
                        </form>
                        <v-row>
                            <v-col cols="12">
                                <router-link to="lista-productos-compras">
                                    <v-btn color="red" class="white--text mr-2">
                                        Cancelar
                                    </v-btn>
                                </router-link>
                                <v-btn
                                    v-if="!producto.id && rol != 4 && rol != 5"
                                    @click="saveproducto"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    >Guardar</v-btn
                                >
                                <v-btn
                                    v-if="producto.id && rol != 4 && rol != 5"
                                    @click="saveproducto"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    >Actualizar</v-btn
                                >
                                <v-btn
                                    v-if="producto.id && rol != 4 && rol != 5"
                                    @click="
                                        isDeleteProductoCompraDialogVisible = true
                                    "
                                    :disabled="isloading"
                                    color="red"
                                    class="white--text"
                                    >Eliminar</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>

        <!-- Confirmacion de eliminacion de producto de compra-->
        <DeleteDialog
            v-model="isDeleteProductoCompraDialogVisible"
            @delete="deleteproducto"
        ></DeleteDialog>
    </v-container>
</template>

<script>
import proveedoresSelect from "@/components/general/proveedoresSelect.vue";
import DeleteDialog from "../../../components/general/dialogs/DeleteDialog.vue";
export default {
    components: {
        proveedoresSelect,
        DeleteDialog,
    },
    data() {
        return {
            isDeleteProductoCompraDialogVisible: false,
            ivas: [],
            nueva: 0,
            producto: {
                id: null,
                precio_original: 0,
                precio: 0,
                nombre: "",
                cantidad: 0,
                codigo: "",
                cuenta_contable: "",
                id_proveedor: null,
            },
        };
    },
    watch: {
        //
    },
    created() {
        if (this.$route.query.id) {
            this.getproducto(this.$route.query.id);
        }
        this.getCuentas();
        this.getIvas();
    },
    methods: {
        getCuentas() {
            let prefix = 60;
            axios.get(`api/get-cuentas/${prefix}`).then(
                (res) => {
                    this.cuentas = res.data.success;

                    let numero = 0;
                    this.cuentas.forEach((element) => {
                        if (numero < element.numero) {
                            numero = element.numero;
                        }
                    });

                    this.cliente.cuenta = parseInt(numero) + 1;
                },
                (res) => {}
            );
        },
        getIvas() {
            let prefix = 430;
            axios.get(`api/get-iva`).then(
                (res) => {
                    this.ivas = res.data.success;
                },
                (res) => {}
            );
        },
        getproducto(producto_id) {
            axios.get(`api/get-producto-compra/${producto_id}`).then(
                (res) => {
                    this.producto = res.data.success;
                    this.producto.cuenta_contable =
                        this.producto.cuenta_contable.numero;
                },
                (res) => {}
            );
        },
        saveproducto() {
            axios
                .post("api/save-producto-compra", this.producto)
                .then((res) => {
                    this.$router.push("lista-productos-compras");
                })
                .catch((error) => {
                    if (error.response?.status === 400 && error.response?.data?.error) {
                        this.$custom_error(error.response.data.error);
                    } else {
                        this.$custom_error("Algo salio mal");
                    }
                });
        },
        deleteproducto() {
            axios.delete(`api/delete-producto-compra/${this.producto.id}`).then(
                (res) => {
                    this.isDeleteProductoCompraDialogVisible = false;
                    this.$router.push("lista-productos-compras");
                },
                (res) => {}
            );
        },
    },
    filters: {},

    computed: {
        rol: function () {
            return localStorage.getItem("role");
        },
        isloading() {
            return this.$store.getters.getloading;
        },
    },
};
</script>
